import ENDPOINT from "@/api/endpoints";
import { HTTP,buildQueries, HTTP_FILE } from "@/api/http-common";

let qs = require("qs");

export function callApiTaoVanBanDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.CREATE,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSuaVanBanDi(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.UPDATE}${payload.Id}`,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}
export function callApiSuaVanBanDiBanHanh(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.UPDATE_DA_BAN_HANH}${payload.Id}`,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCheckSoDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.CHECK_SO_DI,
    method: "GET",
    params: payload,
  });
}

export function callApiCheckTrungSoDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.CHECK_TRUNG_SO_DI,
    method: "GET",
    params: payload,
  });
}

export function callApiGoiSoBiGiu(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.SO_BI_GIU,
    method: "GET",
    params: payload,
  });
}

export function callApiSinhSoNoiBo(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.SINH_SO_NOI_BO,
    method: "GET",
    params: payload,
  });
}

export function callApiLayDanhSachVanBanDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.SEARCH,
    method: "POST",
    data: payload,
  });
}

export function callApiUpdateFileVanBanDi(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.VAN_BAN_DI.UPDATE_FILE}/${payload.id}`,
    method: "PUT",
    data: payload.data,
  });
}

export function callApiDeleteFileVanBanDi(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.VAN_BAN_DI.DELETE_FILE}/${payload.id}`,
    method: "DELETE",
    data: payload.data,
  });
}

export function callApiThemDonViNgoaiHeThong(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.THEM_DON_VI_NGOAI,
    method: "POST",
    data: payload,
  });
}

export function callApiLayMultiDanhSachVanBanDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.GET_MULTI,
    method: "POST",
    data: payload,
  });
}

export function callApiLayDanhSachVanBanDenCuaVanBanDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.GET_LIST_VB_DEN,
    method: "POST",
    data: payload,
  });
}

export function callApiMultiVanBanDen(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.MULTI_VAN_BAN_DEN,
    method: "POST",
    data: payload,
  });
}

export function callApiFileDinhKem(payload) {
  return HTTP_FILE({
    url: ENDPOINT.VAN_BAN_DI.FILE_DINH_KEM + `/${payload}`,
    method: "GET",
  });
}

export function callApiGetDonViCanBo(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.GET_DON_VI_CAN_BO + `?${payload}`,
    method: "GET",
  });
}

export function callApiUploadFiles(payload) {
  return HTTP_FILE({
    url: ENDPOINT.VAN_BAN_DI.UPLOAD_FILES,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLaySoLuongVanBanDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.SO_LUONG,
    method: "GET",
    data: payload,
    params: payload,
  });
}

export function callApiLaySoLuongVanBanDiDashboard(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.SO_LUONG_DASHBOARD,
    method: "GET",
    data: payload,
    params: payload,
  });
}

export function callXemChiTietVanBanDi(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.DETAIL}${payload.id}?LoaiDuLieu=${payload.LoaiDuLieu}`,
    method: "GET",
  });
}

export function callThongTinChungVanBanDi(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.THONG_TIN_CHUNG}${payload}`,
    method: "GET",
  });
}

export function callGuiLaiFileDonVi(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.VAN_BAN_DI.GUI_LAI_FILE_DON_VI}${payload}`,
    method: "GET",
  });
}

export function callThongTinGuiVanBan(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.THONG_TIN_GUI_VAN_BAN}${payload}`,
    method: "GET",
  });
}

export function callApiChuyenVung(payload) {
  return HTTP({
    url: `${ENDPOINT.COMMON.CHUYEN_VUNG}${payload}`,
    method: "POST",
  });
}

export function callThongTinYKien(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.THONG_TIN_Y_KIEN}${payload}`,
    method: "GET",
  });
}

export function callApiGetSoDiLonNhat(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.LAY_SO_DI_MAX,
    method: "GET",
    params: payload,
  });
}

export function callApiGetFileNhieuVanBan(payload) {
  return HTTP_FILE({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.LAY_FILE_VAN_BAN,
    method: "POST",
    data: payload,
  });
}

export function callApiTrinhKy(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + `${payload.Id}/trinh-ky`,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGanDonViVaoFile(payload) {
  return HTTP({
    url:
      ENDPOINT.VAN_BAN_DI.GAN_DON_VI_VAO_FILE +
      `${payload.Id}/gan-don-vi-vao-file`,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaYKien(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.XIN_Y_KIEN}${ENDPOINT.VAN_BAN_DI.XOA_Y_KIEN}${payload.id}`,
    method: "DELETE",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXoaVanBanDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME,
    method: "DELETE",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiXinYKien(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.XIN_Y_KIEN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiChoYKien(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.CHO_Y_KIEN,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSuaYKien(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.SUA_Y_KIEN,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiUpdateYKien(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.UPDATE_Y_KIEN,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSuaXinYKienVanBanDi(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.XIN_Y_KIEN + `${payload.Id}`,
    method: "PUT",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiKySoFile(payload) {
  return HTTP_FILE({
    url:
      ENDPOINT.VAN_BAN_DI.KY_SO_FILE +
      `${payload.idFile}/${payload.idVanBanDi}`,
    method: "POST",
    data: payload,
    paramsSerializer: (params) => {
      return qs.stringify(params);
    },
    asyncLoading: true,
  });
}

export function callApiDuyetVB(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.DUYET,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiCapSo(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.CAP_SO,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiTraSo(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.TRA_SO}${payload}/tra-lai`,
    method: "POST",
    asyncLoading: true,
  });
}

export function callApiNhanSo(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NHAN_SO,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiHuyDuyet(payload) {
  return HTTP({
    url:
      ENDPOINT.VAN_BAN_DI.NAME +
      `${payload.Id}/${ENDPOINT.VAN_BAN_DI.HUY_DUYET}`,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiHuyTrinhKy(payload) {
  return HTTP({
    url:
      ENDPOINT.VAN_BAN_DI.NAME +
      `${payload.Id}/${ENDPOINT.VAN_BAN_DI.HUY_TRINH_KY}`,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDanhSachNguoiDuocTraLai(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload}${ENDPOINT.VAN_BAN_DI.DANH_SACH_NGUOI_DUOC_TRA_LAI}`,
    method: "GET",
  });
}

export function callApiTraLai(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload.Id}${ENDPOINT.VAN_BAN_DI.TRA_LAI}`,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetListXinSo(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.LIST_XIN_SO,
    method: "POST",
    data: payload,
  });
}

export function callApiBanHanh(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.BAN_HANH,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiBanHanhTruc(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${ENDPOINT.VAN_BAN_DI.BAN_HANH_LEN_TRUC}`,
    method: "POST",
    asyncLoading: true,
    data: payload,
  });
}

export function callApiBanHanhVanBanError(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.GUI_VAN_BAN_ERROR,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiDanhDauVanBanKhongBanHanhLai(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.KHONG_VAN_BAN_ERROR,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiSaoChep(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.SAO_CHEP}${payload.Id}/sao-chep`,
    method: "POST",
    data: payload.data,
    asyncLoading: true,
  });
}

export function callApiBanHanhBoSung(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.NAME + ENDPOINT.VAN_BAN_DI.BAN_HANH_BO_SUNG,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayDonViDaBanHanh(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload}${ENDPOINT.VAN_BAN_DI.DON_VI_BAN_HANH}`,
    method: "GET",
  });
}

export function callApiThuHoiDaBanHanh(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload.Id}${ENDPOINT.VAN_BAN_DI.THU_HOI_DA_BAN_HANH}`,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiTrinhKyTiepTheo(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.TRINH_KY_TIEP_THEO}${payload.id}/trinh-ky-tiep-theo`,
    method: "POST",
    data: payload.data,
    asyncLoading: true,
  });
}

export function callApiPhanXuLy(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload.Id}${ENDPOINT.VAN_BAN_DI.PHAN_XU_LY}`,
    method: "POST",
    data: payload,
  });
}

export function callApiThuHoiSo(payload) {
  return HTTP({
    url: ENDPOINT.VAN_BAN_DI.THU_HOI_SO,
    method: "DELETE",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiLayLSCapNhat(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload}${ENDPOINT.VAN_BAN_DI.LS_CAP_NHAT}`,
    method: "GET",
  });
}

export function callApiLayLSTraLai(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload}${ENDPOINT.VAN_BAN_DI.LS_TRA_LAI}`,
    method: "GET",
  });
}

export function callApiLayLSThuHoi(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload}${ENDPOINT.VAN_BAN_DI.LS_THU_HOI}`,
    method: "GET",
  });
}

export function callApiLayLSHuyDuyet(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload}${ENDPOINT.VAN_BAN_DI.LS_HUY_DUYET}`,
    method: "GET",
  });
}

export function callApiLayLuongXuLy(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload}${ENDPOINT.VAN_BAN_DI.LUONG_XU_LY}`,
    method: "GET",
  });
}

export function callApiLayLuongXuLyToken(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload.processId}${ENDPOINT.VAN_BAN_DI.LUONG_XU_LY}`,
    method: "GET",
    params: { token: payload.token },
  });
}

export function callApiLayLichSuKyDuyet(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.LICH_SU_KY_DUYET}${payload}/xem-lich-su-luong-xu-ly`,
    method: "GET",
  });
}

export function callApiLayLichSuLienThong(payload) {
  return new Promise((resolve, reject) => {
    return HTTP.get(
      `${ENDPOINT.VAN_BAN_DI.NAME}${ENDPOINT.VAN_BAN_DI.LS_LIEN_THONG}?${buildQueries(payload)}`
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function callApiLayLSTheoDoiVB(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${payload}${ENDPOINT.VAN_BAN_DI.LS_THEO_DOI_VAN_BAN}`,
    method: "GET",
  });
}

export function callGetDonViNgangCap(data) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.GET_TREE_XIN_Y_KIEN}`,
    method: "GET",
    params: data || {},
  });
}

export function callApiLayNguoiXuLyTiepTheo(id) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${id}${ENDPOINT.VAN_BAN_DI.NGUOI_XU_LY_TIEP_THEO}`,
    method: "GET",
  });
}

export function callApiLayLuongKyDuyet(id) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${ENDPOINT.VAN_BAN_DI.THONG_TIN_KY_DUYET}/${id}`,
    method: "GET",
  });
}

export function callApiExportVB(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${ENDPOINT.VAN_BAN_DI.EXPORT}`,
    method: "POST",
    data: payload,
  });
}

export function callApiDoiSo(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${ENDPOINT.VAN_BAN_DI.DOI_SO}`,
    method: "POST",
    data: payload,
    asyncLoading: true,
  });
}

export function callApiGetDonViDaBanHanh(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${ENDPOINT.VAN_BAN_DI.DON_VI_DA_BAN_HANH}`,
    method: "GET",
    params: payload,
  });
}

export function callApiXemKyDienTu(payload) {
  return HTTP_FILE({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${ENDPOINT.VAN_BAN_DI.XEM_KY_DIEN_TU}`,
    method: "POST",
    data: payload,
  });
}

export function callApiGetDanhSachVanThuLanhDaoXinSoBo(payload) {
  return HTTP({
    url: `${ENDPOINT.VAN_BAN_DI.NAME}${ENDPOINT.VAN_BAN_DI.DS_VAN_THU_LANH_DAO_XIN_SO_BO}`,
    method: "GET",
    params: payload,
  });
}
